var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDesktop)?_c('accessible-panel-resizer',{attrs:{"side":"right","custom-class":"gl-pointer-events-auto","aria-label":_vm.$options.i18n.resizeLabel,"value":_vm.value,"default-size":_vm.$options.widths.default,"min-size":_vm.$options.widths.min,"max-size":_vm.$options.widths.max},on:{"input":_vm.onResize,"resize-end":_vm.onResizeEnd}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }